module.exports = __webpack_public_path__ + "img/43.2a21e7f0.jpg";